import angular from 'angular'
import financial from './financial'
import invoiceGather from './invoiceGather'
import reconciliationAccount from './reconciliationAccount'

export default angular
    .module('input.financialCounting', [financial, reconciliationAccount, invoiceGather])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.financialCounting', {
            abstract: true,
            url: '/financialCounting',
            template: '<div ui-view></div>',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/index.js